module.exports = __webpack_public_path__ + "img/2.2314f521.jpg";